import React, { Component } from 'react'
import { connect } from "react-redux";
import Grid from "../../../../components/grid";
import DropDownRender from '../../../../components/grid/dropDown'
import { sortBy, } from 'lodash';
import { BILLING_CATEGORIES } from '../../../../utils/constants';
import { getBillingServices, UpdateBillingServices, editClientData } from "../../../../store/actions";
class BillingServices extends Component {
    state = {
        loading: false,
        isSelectedRowData: "",
        isShow: false,
        isAddOrderShow: false,
        billingServices: [],
        columnDefs: [

            {
                headerName: "Billing Category",
                field: "billingCategory",
                resizable: true,
                width: 150,
                flex: 1,
                rowGroup: true,
                hide: true,

            },

            {
                headerName: "Service Name",
                field: "serviceName",
                width: 110,
                flex: 1,


            },
            {
                headerName: "Description",
                field: "description",
                resizable: true,
                width: 150,
                flex: 1,


            },
            {
                headerName: "Created At",
                field: "createdAt",
                resizable: true,
                width: 150,
                flex: 1,

                valueFormatter: params => params.value ? new Date(params.value).toLocaleString() : ""
            },
            {
                headerName: "Billing Category",
                field: "billingCategory",
                resizable: true,
                width: 150,
                flex: 1,
                cellRenderer: DropDownRender,
                cellRendererParams: {
                    onChange: (params) => this.onClickBillingCategory(params),
                    optionsList: BILLING_CATEGORIES,
                    dataPropName: "billingCategory"
                },
            }

        ],
        rowData: [],
        searchText: '',
    };
    billingServices = [];

    onGridReady = async (params) => {
        this.setState({ apiParams: params });
        this.gridApi = params.api;
        this.columnApi = params.columnApi;
        const updateData = (data) => {
            this.setState({ rowData: data });
        }
        this.gridApi.showLoadingOverlay();
        await this.props.getBillingServices();
        const BillingServicesList = sortBy(this.props.BillingServicesReducer.map(b => {
            b.billingCategory = b.billingCategory || "Uncategorized";
            return b;
        }), "billingCategory");
        updateData(BillingServicesList || []);
    }
    searchInput = (e) => {
        this.setState({ searchText: e.target.value });
        this.gridApi.purgeInfiniteCache();
    }
    refreshGrid = () => {
        this.gridApi.showLoadingOverlay();
        this.onGridReady(this.state.apiParams);
    }

    saveServices = async () => {
        let payload = {
            billingServices: this.state.billingServices
        }
        await this.props.UpdateBillingServices(payload);
        this.refreshGrid()
    };

    onClickBillingCategory = (data) => {
        let findIndex = this.billingServices.findIndex(res => res.systemId === data.systemId);
        if (findIndex === -1) {
            this.billingServices.push(data)
        } else {
            this.billingServices[findIndex] = data;
        }
        this.setState({ billingServices: this.billingServices });
    }

    render() {
        return (
            <>
                <h2 className="page_title">Billing Discrepancy</h2>

                <div className="shadow_white_box full-box mt-0">
                    <div className="filter-list d-flex align-items-center justify-content-between">
                        <div className="filter-field d-flex">
                            <input type="text" placeholder="Search" autoComplete="off" onChange={(e) => this.searchInput(e)} />
                        </div>

                        <div className="filter-field d-flex">
                            <button className="mla fs12 primary mini" onClick={this.saveServices}>Save</button>
                        </div>
                    </div>
                    <div className="clients_grid">
                        <Grid
                            columnDefs={this.state.columnDefs}
                            rowData={this.state.rowData}
                            groupDefaultExpanded={1}
                            onGridReady={this.onGridReady}
                            height='600px'
                        >
                        </Grid>
                    </div>
                </div>

            </>
        )
    }
}


const mapStateToProps = ({ BillingServicesReducer }) => ({ BillingServicesReducer });
export default connect(mapStateToProps, { getBillingServices, UpdateBillingServices, editClientData })(BillingServices);
